/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-12-18 09:56:51
 * @LastEditTime: 2026-01-08 16:35:15
 */
import React, { useEffect, useState, useRef } from "react";
import { message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import refreshImg from "../../assets/refresh.png";
import { xcxCheckLogin,wxRCheckLogin } from "../../../../api/login/index.js";
import { getRequestParams,handleLocHref } from "@/utils/index.js";
import { zhugeTrack } from "@/utils/utils";
import type { ParamsType } from "../../types";
import { useAppSelector } from "@/redux/hooks";
import wxBg from '@/assets/images/login/wx-bg.png';
import "./index.scss";

interface Props {
  type: number;
  loginSuccess: (params: any) => void;
}
const WXScan: React.FC<Props> = ({type,loginSuccess}) => {
  const clSetTime = useRef<ReturnType<typeof setTimeout> | null>(null);
  const controllerRef = useRef<AbortController | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useAppSelector((state) => state.common);
  const [codeTab, setCodeTab] = useState(0);
  // 当前时间戳
  const [timestamp, setTimestamp] = useState<number>(new Date().getTime());
  // 小程序二维码地址
  const [qrCodeUrl, setQrCodeUrl] = useState<string>("");
  // 二维码失效
  const [qrcodeInvalid, setQrcodeInvalid] = useState<boolean>(false);
  // 时间戳改变的时候刷新二维码
  useEffect(() => {
    if(codeTab === 0) {
      setQrCodeUrl(
        `/uc/wx/getServiceQrCode.json?scene=${timestamp}`
      );
    }else {
      setQrCodeUrl(
        `/uc/wx/getAppletQrCode.json?scene=${timestamp}&path=pages/originqcLogin/index`
      );
    }
  }, [timestamp,codeTab]);

  useEffect(() => {
    setQrcodeInvalid(false);
  },[codeTab])

  useEffect(() => {
    clearTimeAll();
    if (!qrCodeUrl) {
      return;
    }
    let isMounted = true; // 组件挂载标志

    // 小程序登录接口轮询
    const handleXcxCheckLogin = async (): Promise<void> => {
      clearTimeAll();
      controllerRef.current = new AbortController();
      const apiCall = type === 1 ? xcxCheckLogin : wxRCheckLogin;
      const result: ParamsType = await apiCall({ scene: timestamp },controllerRef.current.signal);
      const res = result.data;
      if (isMounted && res.success) {
        if(res.obj?.scene && res.obj?.scene !== '') {
          navigate(`/l/verify/${type}/${res.obj?.scene}${location.search}`)
        }else {
          message.info("登录成功");
          loginSuccess(res.obj);
          if(!getRequestParams("forward")) {
          window.open(handleLocHref('') + language, "_self");
          }
          zhugeTrack("用户登录", {
            登录状态: "登录成功",
            登录方式: "微信登录",
          });
        }
        return;
      }
      // 轮询
      if (res.code === 10071 && isMounted) {
        clearTimeAll();
        clSetTime.current = setTimeout(() => {
          handleXcxCheckLogin();
        }, 2000);
      } else if (res.code === 10070) {
        // 二维码失效
        setQrcodeInvalid(true);
        clearTimeAll();
      } else if (res.code === 10075 && isMounted) {
        setTimestamp(new Date().getTime());
        message.error(res.message);
      }
    };
    const imgtest: HTMLImageElement = new Image();
    imgtest.src = qrCodeUrl;
    // 二维码加载完成之后轮询接口
    imgtest.onload = function () {
      handleXcxCheckLogin();
    };
    return () => {
      isMounted = false; // 标记组件卸载
      clearTimeAll();
      controllerRef.current?.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qrCodeUrl]);

  const clearTimeAll = () => {
     if (clSetTime.current) {
      clearTimeout(clSetTime.current);
      clSetTime.current = null;
    }
  }
  // 刷新二维码
  const handleRefreshQRcode = (): void => {
    setTimestamp(new Date().getTime());
    setQrcodeInvalid(false);
  };
  return (
    <div className="login-box-content-code">
      <div className='code-title'>微信扫码 一键登录</div>
      {
        codeTab === 0 ?
        <p>使用微信扫一扫，关注“本源量子云社区”服务<br />号即可登录，未注册微信将自动创建云平台账号</p>:
        <p>使用微信扫一扫，在小程序内选择要登录的账号<br />如您是新用户，建议您使用服务号</p>
      }
      <div className="wx-login-box">
        {
          codeTab === 0 &&
          <img src={wxBg} alt='' />
        }
        <img className={`${codeTab === 0 && 'wx-img'}`} src={qrCodeUrl} alt='' />
        <div
          onClick={handleRefreshQRcode}
          className={`refresh-err ${qrcodeInvalid ? "active" : ""} ${codeTab===0&&'refresh-service-err'}`}
        >
          <img src={refreshImg} alt="刷新" />
          <div>二维码失效</div>
          <div>请点击重试</div>
        </div>
      </div>
      
      {
        type === 1 &&
        <>
        {
          codeTab === 0 ?
          <div className="change-code">
            <span className='tab-btn' onClick={()=>{setQrCodeUrl('');setCodeTab(1)}}>切换至小程序码</span>
            <span>（适用于之前扫描小程序码登录的老用户）</span>
          </div>:
          <div className="change-code">
            <span className='tab-btn' onClick={()=>{setQrCodeUrl('');setCodeTab(0)}}>切换至服务号</span>
          </div>
        }
        </>
        
      }

    </div>
  );
};

export default WXScan;
